import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./router";
import reportWebVitals from "./reportWebVitals";
import { Provider, useDispatch, useSelector } from "react-redux";
// import Chart from "./components/Chat"
import GoTop from "./components/GoTop"

import "./lang/i18n";
import "./index.css"; //公共样式
import "./App.css"; //pc样式 
import store from "./store";
import { stateType } from "./store/reducer";
import Loding from "./components/loding";
import { createLoginSuccessAction } from "./store/actions";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
    {/* <Chart /> */}
    <GoTop />
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
